import {utilModule} from '../module.js';

utilModule.directive('nsReplaceDashes', ['nsUtil', function() {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {

            ele.on('blur', function () {
                scope.$apply(function () {
                    let x = ele.val();
                    x = x.replace(/－/g,"-");
                    x = x.replace(/―/g,"-");
                    x = x.replace(/−/g,"-");
                    x = x.replace(/–/g,"-");
                    x = x.replace(/₋/g,"-");

                    ctrl.$setViewValue(x);
                });
            });
        }
    };
}]);
